function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.757 19.497c2.07 0 3.75-1.679 3.75-3.75 0-2.07-1.68-3.75-3.75-3.75-2.071 0-3.75 1.68-3.75 3.75 0 2.071 1.679 3.75 3.75 3.75zM14.74 3c1.242 0 2.25 1.007 2.25 2.25v5.745c1.782.84 3.016 2.652 3.016 4.752 0 2.9-2.35 5.25-5.25 5.25-1.47 0-2.798-.603-3.75-1.576v.076H5.75c-1.243 0-2.25-1.007-2.25-2.25V5.25C3.5 4.007 4.507 3 5.75 3h8.99zm0 1.5H5.75c-.414 0-.75.336-.75.75v11.997c0 .414.336.75.75.75h4.262c-.324-.681-.505-1.444-.505-2.25 0-2.9 2.35-5.25 5.25-5.25.249 0 .494.018.734.051V5.25c0-.414-.336-.75-.75-.75zm.496 10.006c.27-.313.744-.347 1.058-.076.313.271.347.745.076 1.058l-1.546 1.786c-.18.209-.496.232-.705.051l-.033-.03-.995-1.03c-.288-.298-.28-.773.018-1.061.298-.288.773-.28 1.06.018l.236.244.83-.96zm-7.98-7.009c-.415 0-.75-.336-.75-.75s.335-.75.75-.75h6c.414 0 .75.336.75.75s-.336.75-.75.75h-6zm0 3c-.415 0-.75-.336-.75-.75s.335-.75.75-.75h3c.414 0 .75.336.75.75s-.336.75-.75.75h-3z"
});

var Svg011Returned = function Svg011Returned(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default Svg011Returned;


//////////////////
// WEBPACK FOOTER
// ./src/icons/order-status/011-returned.svg
// module id = 275
// module chunks = 0 1